import { render, staticRenderFns } from "./HotelList.vue?vue&type=template&id=245aff92&"
import script from "./HotelList.vue?vue&type=script&lang=js&"
export * from "./HotelList.vue?vue&type=script&lang=js&"
import style0 from "./HotelList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports